import { Component, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'plugin-apollo-helpers-modal-align',
    templateUrl: './modal-align.component.html',
    styleUrls: ['./modal-align.component.scss']
})

export class PluginApolloHelpersModalAlignComponent{
	
	@Output() action = new EventEmitter<any>();

	constructor(){}

	actionButton(type){
		this.action.emit(type);
	}
}